import {
    Box,
    Drawer,
    Toolbar,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    IconButton,
    Divider,
    Avatar,
    Menu,
    MenuItem,
    useTheme,
    Collapse,
  } from '@mui/material'
  import ExpandMore from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FlightIcon from '@mui/icons-material/Flight';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AlbumIcon from '@mui/icons-material/Album';
import InfoIcon from '@mui/icons-material/Info';
import PaymentsIcon from '@mui/icons-material/Payments';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import FeedIcon from '@mui/icons-material/Feed';
import FactCheckIcon from '@mui/icons-material/FactCheck';
  import {
    Logout as LogoutIcon,
    Menu as MenuIcon,
  } from '@mui/icons-material'
  import { useNavigate } from 'react-router-dom'
  import { useState, useEffect } from 'react'
  import { useThemeMode } from '../theme/ThemeContext'
  import Logo from '../assets/images/zenvoya+logo.png'
  import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
  import InventoryIcon from '@mui/icons-material/Inventory';
  import DataArrayIcon from '@mui/icons-material/DataArray';
  import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
  import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
  // import MonitorIcon from '@mui/icons-material/Monitor'; // Monitoring Tool hidden
  import ArticleIcon from '@mui/icons-material/Article';
  import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
  import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
  import ManageSearchIcon from '@mui/icons-material/ManageSearch';
  import DashboardIcon from '@mui/icons-material/Dashboard';
  import { useLocation } from 'react-router-dom';
  import React, { ReactNode } from "react";
  import toast, { Toaster } from 'react-hot-toast';
  import { useGlobalContext } from '../operations/globalContext';

  interface AdminLayoutProps {
  children: ReactNode;
}

interface UserDetails {
  name?: string;
  email?: string;
  id?: string | number;
  role?: number;
}

  const drawerWidth = 240
  const collapsedDrawerWidth = 50 // Icon + padding width
  
  const AdminLayout = ({ children }: AdminLayoutProps) => {
    const [isHovering, setIsHovering] = useState(false)
    const [collapsed, setCollapsed] = useState(true);
    const isSidebarFullyOpen = !collapsed || isHovering;

    const navigate = useNavigate()
    const theme = useTheme()
    const { toggleColorMode } = useThemeMode()

    const { userDetails: contextUserDetails } = useGlobalContext() as { userDetails: UserDetails };
    const storedUserDetails: UserDetails = (() => {
      try {
        const raw = localStorage.getItem('userDetails');
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    })();
    const userDetails: UserDetails = Object.keys(contextUserDetails ?? {}).length > 0
      ? contextUserDetails
      : storedUserDetails;

    const displayName = userDetails?.name ?? userDetails?.email ?? 'Admin';
    const avatarInitial = displayName !== 'Admin'
      ? displayName.charAt(0).toUpperCase()
      : 'A';
  
    const [mobileOpen, setMobileOpen] = useState(false)
  
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const openMenu = Boolean(anchorEl)

    // Only one section/subsection open at a time
      const [openSection, setOpenSection] = useState<string | null>(null)
      const [openSubSection, setOpenSubSection] = useState<string | null>(null)
      const [activeAttribute, setActiveAttribute] = useState<string | null>(null)
  
    const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget)
    }
  
    const handleMenuClose = () => {
      setAnchorEl(null)
    }

    const handleLogout = () => {
      // Clear all user data from localStorage
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('userDetails')
      localStorage.removeItem('userId')

      // Show success toast
      toast.success('Logout Successfully')

      // Navigate to login page
      navigate('/auth/login')
    }

    const toggleSidebar = () => {
      setCollapsed(!collapsed)
    }
  
    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen)
    }

    // const handleParentClick = (section: string) => {
    //   setOpenSection(prev => prev === section ? null : section)
    //   setOpenSubSection(null)
    // }

    const handleParentClick = (section: string) => {
  if (!isSidebarFullyOpen) return; // Prevent toggle if sidebar is collapsed
  setOpenSection((prev) => (prev === section ? '' : section));
  setOpenSubSection(''); // Optional: reset sub-section
};

  
    // const handleChildClick = (subSection: string) => {
    //   setOpenSubSection(prev => prev === subSection ? null : subSection)
    // }

    const handleChildClick = (subSection: string) => {
  if (!isSidebarFullyOpen) return; // Prevent toggle if sidebar is collapsed
  setOpenSubSection((prev) => (prev === subSection ? '' : subSection));
};

useEffect(() => {
  if (!isSidebarFullyOpen) {
    setOpenSection('');
    setOpenSubSection('');
  }
}, [collapsed, isHovering]);


    const location = useLocation();

const pageTitleMap: { [key: string]: string } = {
  '/flight-service-fees': 'Flight',
  '/flight-markups': 'Flight',
  '/flight-dropnet': 'Flight',
  '/stay-service-fees': 'Stay',
  '/stay-markups': 'Stay',
  '/stay-discounts': 'Stay',
  '/stay-suppliers': 'Stay',
  '/stay-regions': 'Stay',
  '/flight-supplier': 'Flight',
  '/flight-regions': 'Flight',
  '/continents': 'Data Management',
  '/countries': 'Data Management',
  '/cities': 'Data Management',
  '/carry-on-baggage': 'Data Management',
  '/payment-methods': 'Data Management',
  '/subscription-plans': 'Data Management',
  '/airlines': 'Data Management',
  '/airports': 'Data Management',
  '/services': 'Data Management',
  '/users': 'Users',
  '/roles': 'Roles',
  '/my-account': 'My Account',
  '/update-password': 'Update Password',
  '/flight-office': 'Flight',
  '/sprint-dashboard': 'Sprint Dashboard',
  '/sprint-dashboard/overview': 'Sprint Dashboard',
  '/sprint-dashboard/productivity': 'Sprint Dashboard',
  '/sprint-dashboard/command-center': 'Sprint Dashboard',
  '/sprint-dashboard/staff': 'Sprint Dashboard',
  '/supplier-configuration/flight': 'Supplier Configuration',
  '/supplier-configuration/hotel': 'Supplier Configuration',
  '/supplier-configuration/activity': 'Supplier Configuration',
  '/service-fee-configuration/flight': 'Service Fee Configuration',
  '/service-fee-configuration/hotel': 'Service Fee Configuration',
  '/service-fee-configuration/activity': 'Service Fee Configuration',
  '/monitoring-tool': 'Monitoring Tool',
  '/log-monitor': 'Log Monitor',
  '/error-monitor': 'Daily Error Monitor',
  '/manual-booking/flight': 'Manual Booking',
  '/manual-booking/hotel': 'Manual Booking',
};

const pageTitle = pageTitleMap[location.pathname] || 'Admin Engine';

  
    const drawerContent = (
      <Box height="100%" display="flex" flexDirection="column" justifyContent="space-between">
        <Box>
          <Box component="div" className='sidebarLogoWrap'>
          <img src={Logo} alt="logo" className='sidebarLogo' />
          </Box>
          
          <List component="nav">
            <ListItemButton onClick={() => { handleParentClick('superParent'); navigate('/super-screen');}}>
              <ListItemIcon className='headingIcon'><LaptopChromebookIcon /></ListItemIcon>
              <ListItemText primary="Super Screen" 
              className={`headingTitle ${openSection === 'superParent' ? 'openCollapse' : ''}`} />
              {openSection === 'superParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
             <ListItemButton onClick={() => { handleParentClick('metaParent'); navigate('/meta-plan');}}>
              <ListItemIcon className='headingIcon'><LaptopChromebookIcon /></ListItemIcon>
              <ListItemText primary="Meta Plan" 
              className={`headingTitle ${openSection === 'metaParent' ? 'openCollapse' : ''}`} />
              {openSection === 'metaParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('adminParent'); navigate('/super-admin');}}>
              <ListItemIcon className='headingIcon'><LaptopChromebookIcon /></ListItemIcon>
              <ListItemText primary="Super Admin" 
              className={`headingTitle ${openSection === 'adminParent' ? 'openCollapse' : ''}`} />
              {openSection === 'adminParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('revenueParent')} >
              <ListItemIcon className='headingIcon'><AttachMoneyIcon /></ListItemIcon>
              <ListItemText primary="Revenue Managment"
              className={`headingTitle ${openSection === 'revenueParent' ? 'openCollapse' : ''}`} />
              {openSection === 'revenueParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
  
            <Collapse in={openSection === 'revenueParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('flightChild')}>
                <ListItemIcon><FlightIcon /></ListItemIcon>
                  <ListItemText primary="Flight" 
                  className={`subheadingTitle ${openSubSection === 'flightChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'flightChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'flightChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight Service Fees'); navigate('/flight-service-fees');}}>
                      <ListItemText primary="Service Fees" className={`subheadingAttribute ${activeAttribute === 'Flight Service Fees' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight Markups'); navigate('/flight-markups');}}>
                      <ListItemText primary="Markups"  className={`subheadingAttribute ${activeAttribute === 'Flight Markups' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight Dropnet'); navigate('/flight-dropnet');}}>
                      <ListItemText primary="Dropnet" className={`subheadingAttribute ${activeAttribute === 'Flight Dropnet' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight Discounts'); navigate('/flight-discount');}}>
                      <ListItemText primary="Discounts" className={`subheadingAttribute ${activeAttribute === 'Flight Discounts' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight Promo Codes'); navigate('/flight-promo-code');}}>
                      <ListItemText primary="Promo Codes" className={`subheadingAttribute ${activeAttribute === 'Flight Promo Codes' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('stayChild')}>
                <ListItemIcon><ApartmentIcon /></ListItemIcon>
                  <ListItemText primary="Stay" 
                  className={`subheadingTitle ${openSubSection === 'stayChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'stayChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'stayChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay Service Fees'); navigate('/stay-service-fees');}}>
                      <ListItemText primary="Service Fees" className={`subheadingAttribute ${activeAttribute === 'Stay Service Fees' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay Markups'); navigate('/stay-markups');}}>
                      <ListItemText primary="Markups"  className={`subheadingAttribute ${activeAttribute === 'Stay Markups' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay Commissions'); navigate('/stay-commissions');}}>
                      <ListItemText primary="Commissions" className={`subheadingAttribute ${activeAttribute === 'Stay Commissions' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay Discounts'); navigate('/stay-discounts');}}>
                      <ListItemText primary="Discounts" className={`subheadingAttribute ${activeAttribute === 'Stay Discounts' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay Promo Codes'); navigate('/stay-promo-codes');}}>
                      <ListItemText primary="Promo Codes" className={`subheadingAttribute ${activeAttribute === 'Stay Promo Codes' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </Collapse>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('supplierParent')}>
              <ListItemIcon className='headingIcon'><InventoryIcon /></ListItemIcon>
              <ListItemText primary="Supplier Management"
              className={`headingTitle ${openSection === 'supplierParent' ? 'openCollapse' : ''}`} />
              {openSection === 'supplierParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
  
            <Collapse in={openSection === 'supplierParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('flightChild')}>
                  <ListItemIcon><FlightIcon /></ListItemIcon>
                  <ListItemText primary="Flight" 
                  className={`subheadingTitle ${openSubSection === 'flightChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'flightChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'flightChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight-Supplier'); navigate('/flight-supplier');}}>
                      <ListItemText primary="Supplier Details" className={`subheadingAttribute ${activeAttribute === 'Flight-Supplier' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight-Office'); navigate('/flight-office');}}>
                      <ListItemText primary="Office ID" className={`subheadingAttribute ${activeAttribute === 'Flight-Office' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight-Airlines'); navigate('/flight-airlines');}}>
                      <ListItemText primary="Airlines Block" className={`subheadingAttribute ${activeAttribute === 'Flight-Airlines' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Flight-Mapping'); navigate('/flight-mapping');}}>
                      <ListItemText primary="Suppliers Mapping" className={`subheadingAttribute ${activeAttribute === 'Flight-Mapping' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('stayChild')}>
                  <ListItemIcon><ApartmentIcon /></ListItemIcon>
                  <ListItemText primary="Stay" 
                  className={`subheadingTitle ${openSubSection === 'stayChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'stayChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'stayChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay-Suppliers'); navigate('/stay-suppliers');}}>
                      <ListItemText primary="Supplier Details" className={`subheadingAttribute ${activeAttribute === 'Stay-Suppliers' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Stay-Mapping'); navigate('/stay-suppliers-mapping');}}>
                      <ListItemText primary="Supplier Mapping" className={`subheadingAttribute ${activeAttribute === 'Stay-Mapping' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </Collapse>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('dataParent')}>
            <ListItemIcon className='headingIcon'><DataArrayIcon /></ListItemIcon>
              <ListItemText primary="Data Management"
              className={`headingTitle ${openSection === 'dataParent' ? 'openCollapse' : ''}`} />
              {openSection === 'dataParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
  
            <Collapse in={openSection === 'dataParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('flightChild')}>
                  <ListItemIcon><FlightIcon /></ListItemIcon>
                  <ListItemText primary="Flight" 
                  className={`subheadingTitle ${openSubSection === 'flightChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'flightChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'flightChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {/* <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Continents'); navigate('/continents');}}>
                      <ListItemText primary="Continents" className={`subheadingAttribute ${activeAttribute === 'Continents' ? 'activeAttribute' : ''}`} />
                    </ListItemButton> */}
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Countries'); navigate('/countries');}}>
                      <ListItemText primary="Countries" className={`subheadingAttribute ${activeAttribute === 'Countries' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Cities'); navigate('/cities');}}>
                      <ListItemText primary="Cities" className={`subheadingAttribute ${activeAttribute === 'Cities' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    {/* <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Payment Methods'); navigate('/payment-methods');}}>
                      <ListItemText primary="Payment Methods" className={`subheadingAttribute ${activeAttribute === 'Payment Methods' ? 'activeAttribute' : ''}`} />
                    </ListItemButton> */}
                    {/* <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Subscription Plans'); navigate('/subscription-plans');}}>
                      <ListItemText primary="Subscription Plans" className={`subheadingAttribute ${activeAttribute === 'Subscription Plans' ? 'activeAttribute' : ''}`} />
                    </ListItemButton> */}
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Airlines'); navigate('/airlines');}}>
                      <ListItemText primary="Airlines" className={`subheadingAttribute ${activeAttribute === 'Airlines' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Airports'); navigate('/airports');}}>
                      <ListItemText primary="Airports" className={`subheadingAttribute ${activeAttribute === 'Airports' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('CarryOnBaggage'); navigate('/carry-on-baggage');}}>
                      <ListItemText primary="Carry on Baggage" className={`subheadingAttribute ${activeAttribute === 'CarryOnBaggage' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    {/* <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Services'); navigate('/services');}}>
                      <ListItemText primary="Services" className={`subheadingAttribute ${activeAttribute === 'Services' ? 'activeAttribute' : ''}`} />
                    </ListItemButton> */}
                  </List>
                </Collapse>
              </List>
            </Collapse>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('userParent')}>
            <ListItemIcon className='headingIcon'><ManageAccountsIcon /></ListItemIcon>
              <ListItemText primary="User Management" 
              className={`headingTitle ${openSection === 'userParent' ? 'openCollapse' : ''}`} />
              {openSection === 'userParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
  
                <Collapse in={openSection === 'userParent'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('Users'); navigate('/users');}}>
                      <ListItemText primary="Create Users" className={`subheadingAttribute ${activeAttribute === 'Users' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('Roles'); navigate('/roles');}}>
                      <ListItemText primary="Roles" className={`subheadingAttribute ${activeAttribute === 'Roles' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('UserAccess'); navigate('/user-access');}}>
                      <ListItemText primary="User Access" className={`subheadingAttribute ${activeAttribute === 'UserAccess' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
                  {/*  */}
                   <ListItemButton onClick={() => { handleParentClick('trackParent'); navigate('/track-fare');}}>
            <ListItemIcon className='headingIcon'><CurrencyExchangeIcon /></ListItemIcon>
              <ListItemText primary="Track Fare" 
              className={`headingTitle ${openSection === 'trackParent' ? 'openCollapse' : ''}`} />
              {openSection === 'trackParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            
            {/* <ListItemButton onClick={() => { setActiveAttribute('TrackFare'); navigate('/track-fare');}}>
              <ListItemIcon className='headingIcon'><CurrencyExchangeIcon /></ListItemIcon>
              <ListItemText primary="Track Fare" className="headingTitle" />
              <ChevronRightIcon/>
            </ListItemButton> */}
            <ListItemButton onClick={() => handleParentClick('configParent')}>
              <ListItemIcon className='headingIcon'><FeedIcon /></ListItemIcon>
              <ListItemText primary="Supplier Configuration"
              className={`headingTitle ${openSection === 'configParent' ? 'openCollapse' : ''}`} />
              {openSection === 'configParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
            <Collapse in={openSection === 'configParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SupplierConfigFlight'); navigate('/supplier-configuration/flight');}}>
                  <ListItemText primary="Flight" className={`subheadingAttribute ${activeAttribute === 'SupplierConfigFlight' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SupplierConfigHotel'); navigate('/supplier-configuration/hotel');}}>
                  <ListItemText primary="Hotel" className={`subheadingAttribute ${activeAttribute === 'SupplierConfigHotel' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SupplierConfigActivity'); navigate('/supplier-configuration/activity');}}>
                  <ListItemText primary="Activity" className={`subheadingAttribute ${activeAttribute === 'SupplierConfigActivity' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
              </List>
            </Collapse>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('feeConfigParent')}>
              <ListItemIcon className='headingIcon'><AttachMoneyIcon /></ListItemIcon>
              <ListItemText primary="Supplier Fees Configuration"
              className={`headingTitle ${openSection === 'feeConfigParent' ? 'openCollapse' : ''}`} />
              {openSection === 'feeConfigParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
            <Collapse in={openSection === 'feeConfigParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('FeeConfigFlight'); navigate('/service-fee-configuration/flight');}}>
                  <ListItemText primary="Flight" className={`subheadingAttribute ${activeAttribute === 'FeeConfigFlight' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('FeeConfigHotel'); navigate('/service-fee-configuration/hotel');}}>
                  <ListItemText primary="Hotel" className={`subheadingAttribute ${activeAttribute === 'FeeConfigHotel' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('FeeConfigActivity'); navigate('/service-fee-configuration/activity');}}>
                  <ListItemText primary="Activity" className={`subheadingAttribute ${activeAttribute === 'FeeConfigActivity' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
              </List>
            </Collapse>
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('misParent'); navigate('/mis');}}>
              <ListItemIcon className='headingIcon'><FeedIcon /></ListItemIcon>
              <ListItemText primary="MIS" 
              className={`headingTitle ${openSection === 'misParent' ? 'openCollapse' : ''}`} />
              {openSection === 'misParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('vendorStatementParent'); navigate('/vendor-statement');}}>
              <ListItemIcon className='headingIcon'><FeedIcon /></ListItemIcon>
              <ListItemText primary="Vendor Statement" 
              className={`headingTitle ${openSection === 'vendorStatementParent' ? 'openCollapse' : ''}`} />
              {openSection === 'vendorStatementParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('airlinelockingParent'); navigate('/airline-blocking');}}>
              <ListItemIcon className='headingIcon'><FeedIcon /></ListItemIcon>
              <ListItemText primary="Airline Blocking" 
              className={`headingTitle ${openSection === 'airlinelockingParent' ? 'openCollapse' : ''}`} />
              {openSection === 'airlinelockingParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('airportParent'); navigate('/airport-search');}}>
              <ListItemIcon className='headingIcon'><ManageSearchIcon /></ListItemIcon>
              <ListItemText primary="Airport Search"
              className={`headingTitle ${openSection === 'airportParent' ? 'openCollapse' : ''}`} />
              {openSection === 'airportParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('manualBookingParent')}>
              <ListItemIcon className='headingIcon'><FactCheckIcon /></ListItemIcon>
              <ListItemText primary="Manual Booking"
              className={`headingTitle ${openSection === 'manualBookingParent' ? 'openCollapse' : ''}`} />
              {openSection === 'manualBookingParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
            <Collapse in={openSection === 'manualBookingParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('ManualBookingFlight'); navigate('/manual-booking/flight');}}>
                  <ListItemText primary="Flight" className={`subheadingAttribute ${activeAttribute === 'ManualBookingFlight' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('ManualBookingHotel'); navigate('/manual-booking/hotel');}}>
                  <ListItemText primary="Hotel" className={`subheadingAttribute ${activeAttribute === 'ManualBookingHotel' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
              </List>
            </Collapse>
            {/*  */}
            {/* Monitoring Tool hidden for now
            <ListItemButton onClick={() => { handleParentClick('monitoringParent'); navigate('/monitoring-tool');}}>
              <ListItemIcon className='headingIcon'><MonitorIcon /></ListItemIcon>
              <ListItemText primary="Monitoring Tool"
              className={`headingTitle ${openSection === 'monitoringParent' ? 'openCollapse' : ''}`} />
              {openSection === 'monitoringParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            */}
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('logMonitorParent'); navigate('/log-monitor');}}>
              <ListItemIcon className='headingIcon'><ArticleIcon /></ListItemIcon>
              <ListItemText primary="Log Monitor"
              className={`headingTitle ${openSection === 'logMonitorParent' ? 'openCollapse' : ''}`} />
              {openSection === 'logMonitorParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            <ListItemButton onClick={() => { handleParentClick('errorMonitorParent'); navigate('/error-monitor');}}>
              <ListItemIcon className='headingIcon'><ArticleIcon /></ListItemIcon>
              <ListItemText primary="Error Monitor"
              className={`headingTitle ${openSection === 'errorMonitorParent' ? 'openCollapse' : ''}`} />
              {openSection === 'errorMonitorParent' ? <ChevronRightIcon /> : <ChevronRightIcon/>}
            </ListItemButton>
            {/*  */}
            {/* Monitoring Setting hidden for now
            <ListItemButton onClick={() => handleParentClick('settingParent')}>
              <ListItemIcon className='headingIcon'><BrowserUpdatedIcon /></ListItemIcon>
              <ListItemText primary="Monitoring Setting"
              className={`headingTitle ${openSection === 'settingParent' ? 'openCollapse' : ''}`} />
              {openSection === 'settingParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
            <Collapse in={openSection === 'settingParent'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('FlightMonitoringSetting'); navigate('/flight-monitoring-setting');}}>
                      <ListItemText primary="Flight" className={`subheadingAttribute ${activeAttribute === 'FlightMonitoringSetting' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('StayMonitoringSetting'); navigate('/stay-monitoring-setting');}}>
                      <ListItemText primary="Stay" className={`subheadingAttribute ${activeAttribute === 'StayMonitoringSetting' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
            */}
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('promotionParent')}>
              <ListItemIcon className='headingIcon'><BrowserUpdatedIcon /></ListItemIcon>
              <ListItemText primary="Promotion" 
              className={`headingTitle ${openSection === 'promotionParent' ? 'openCollapse' : ''}`} />
              {openSection === 'promotionParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
            <Collapse in={openSection === 'promotionParent'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {/* Promo Generation & Promotion Setup hidden per promo_crud-smb-3502 —
                        Promo Code is the live promo_master CRUD surface. Routes and pages
                        are left intact; re-enable these two items to restore them.
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('promoGeneration'); navigate('/promo-generation');}}>
                      <ListItemText primary="Promo Generation" className={`subheadingAttribute ${activeAttribute === 'promoGeneration' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('promotionSetup'); navigate('/promotion-setup');}}>
                      <ListItemText primary="Promotion Setup" className={`subheadingAttribute ${activeAttribute === 'promotionSetup' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    */}
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('promoCode'); navigate('/promo-code');}}>
                      <ListItemText primary="Promo Code" className={`subheadingAttribute ${activeAttribute === 'promoCode' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('bookingParent')}>
            <ListItemIcon className='headingIcon'><FactCheckIcon /></ListItemIcon>
              <ListItemText primary="Booking List" 
              className={`headingTitle ${openSection === 'bookingParent' ? 'openCollapse' : ''}`} />
              {openSection === 'bookingParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>

                <Collapse in={openSection === 'bookingParent'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('TransactionList'); navigate('/transaction-list');}}>
                      <ListItemText primary="Transaction List" className={`subheadingAttribute ${activeAttribute === 'TransactionList' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    {/* <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('ItineraryUpdate'); navigate('/itinerary-update');}}>
                      <ListItemText primary="Itinerary Update" className={`subheadingAttribute ${activeAttribute === 'ItineraryUpdate' ? 'activeAttribute' : ''}`} />
                    </ListItemButton> */}
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('HotelItineraryUpdate'); navigate('/hotel-itinerary-update');}}>
                      <ListItemText primary="Hotel Itinerary Update" className={`subheadingAttribute ${activeAttribute === 'HotelItineraryUpdate' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('FlightManagement'); navigate('/flight-management');}}>
                      <ListItemText primary="Flight Management" className={`subheadingAttribute ${activeAttribute === 'FlightManagement' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
             {/*  */}
            <ListItemButton onClick={() => handleParentClick('sprintParent')}>
            <ListItemIcon className='headingIcon'><DashboardIcon /></ListItemIcon>
              <ListItemText primary="Sprint Dashboard"
              className={`headingTitle ${openSection === 'sprintParent' ? 'openCollapse' : ''}`} />
              {openSection === 'sprintParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>

            <Collapse in={openSection === 'sprintParent'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SprintOverview'); navigate('/sprint-dashboard/overview');}}>
                      <ListItemText primary="Sprint Overview" className={`subheadingAttribute ${activeAttribute === 'SprintOverview' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SprintProductivity'); navigate('/sprint-dashboard/productivity');}}>
                      <ListItemText primary="Productivity" className={`subheadingAttribute ${activeAttribute === 'SprintProductivity' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SprintCommandCenter'); navigate('/sprint-dashboard/command-center');}}>
                      <ListItemText primary="Command Center" className={`subheadingAttribute ${activeAttribute === 'SprintCommandCenter' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('SprintStaff'); navigate('/sprint-dashboard/staff');}}>
                      <ListItemText primary="Staff Productivity" className={`subheadingAttribute ${activeAttribute === 'SprintStaff' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
            {/*  */}
            <ListItemButton onClick={() => handleParentClick('systemParent')}>
            <ListItemIcon className='headingIcon'><SettingsSuggestIcon /></ListItemIcon>
              <ListItemText primary="System" 
              className={`headingTitle ${openSection === 'systemParent' ? 'openCollapse' : ''}`} />
              {openSection === 'systemParent' ? <ExpandMore /> : <ChevronRightIcon/>}
            </ListItemButton>
  
            <Collapse in={openSection === 'systemParent'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('generalChild')}>
                <ListItemIcon><AlbumIcon /></ListItemIcon>
                  <ListItemText primary="General" 
                  className={`subheadingTitle ${openSubSection === 'generalChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'generalChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'generalChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {/* <ListItemButton sx={{ pl: 6 }} onClick={() => setActiveAttribute('Payment Methods')}>
                      <ListItemText primary="Payment Methods" className={`subheadingAttribute ${activeAttribute === 'Payment Methods' ? 'activeAttribute' : ''}`} />
                    </ListItemButton> */}
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Subscription Plans'); navigate('/subscription-plans');}}>
                      <ListItemText primary="Subscription Plans" className={`subheadingAttribute ${activeAttribute === 'Subscription Plans' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('services'); navigate('/services');}}>
                      <ListItemText primary="Services (Air, Accomidation, transfer, restaurant, Activity, etc)" className={`subheadingAttribute ${activeAttribute === 'services' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('mandatoryChild')}>
                <ListItemIcon><InfoIcon /></ListItemIcon>
                  <ListItemText primary="Mandatory Information" 
                  className={`subheadingTitle ${openSubSection === 'manadatoryChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'mandatoryChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'mandatoryChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Info-Air'); navigate('/air');}}>
                      <ListItemText primary="Air (passport, date of birth)" className={`subheadingAttribute ${activeAttribute === 'Info-Air' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Accommodation'); navigate('/accommodation');}}>
                      <ListItemText primary="Accommodation" className={`subheadingAttribute ${activeAttribute === 'Accommodation' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('paymentsChild')}>
                <ListItemIcon><PaymentsIcon /></ListItemIcon>
                  <ListItemText primary="Payments" 
                  className={`subheadingTitle ${openSubSection === 'paymentsChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'paymentsChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'paymentsChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Payment gateways'); navigate('/payment-gateways');}}>
                      <ListItemText primary="Payment Gateways" className={`subheadingAttribute ${activeAttribute === 'Payment gateways' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Payment methods'); navigate('/payment-methods');}}>
                      <ListItemText primary="Payment Methods" className={`subheadingAttribute ${activeAttribute === 'Payment methods' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Currencies'); navigate('/currencies');}}>
                      <ListItemText primary="Currencies" className={`subheadingAttribute ${activeAttribute === 'Currencies' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleChildClick('notificationsChild')}>
                <ListItemIcon><NotificationsActiveIcon /></ListItemIcon>
                  <ListItemText primary="Notifications" 
                  className={`subheadingTitle ${openSubSection === 'notificationsChild' ? 'openCollapse' : ''}`} />
                  {openSubSection === 'notificationsChild' ? <ExpandMore /> : <ChevronRightIcon/>}
                </ListItemButton>
  
                <Collapse in={openSubSection === 'notificationsChild'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Emails'); navigate('/emails');}}>
                      <ListItemText primary="Emails" className={`subheadingAttribute ${activeAttribute === 'Emails' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                    <ListItemButton sx={{ pl: 6 }} onClick={() => { setActiveAttribute('Email Template'); navigate('/email-template');}}>
                      <ListItemText primary="Email Template" className={`subheadingAttribute ${activeAttribute === 'Email Template' ? 'activeAttribute' : ''}`} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('Search Preferences'); navigate('/search-prefereences');}}>
                  <ListItemText primary="Search Preferences" className={`subheadingAttribute ${activeAttribute === 'Search Preferences' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('System-Accommodation'); navigate('/accommodation');}}>
                  <ListItemText primary="Accommodation" className={`subheadingAttribute ${activeAttribute === 'System-Accommodation' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
              </List>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => { setActiveAttribute('Air'); navigate('/air');}}>
                  <ListItemText primary="Air" className={`subheadingAttribute ${activeAttribute === 'Air' ? 'activeAttribute' : ''}`} />
                </ListItemButton>
              </List>
            </Collapse>
          </List>
        </Box>
      </Box>
    )
  
    return (
      <Box sx={{ display: 'flex' }}>
        <Toaster position="top-right" />
        {/* Top AppBar */}
  
        {/* Permanent Drawer */}
        {/* <Drawer
         className="sidebarWrap"
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            width: collapsed ? 60 : drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: collapsed ? 60 : drawerWidth,
              boxSizing: 'border-box',
              overflowX: 'hidden',
              transition: 'width 0.3s'
            }
          }}
          open
        >
          {drawerContent}
        </Drawer> */}

        <Drawer
  className="sidebarWrap"
  variant="permanent"
  onMouseEnter={() => collapsed && setIsHovering(true)}
  onMouseLeave={() => collapsed && setIsHovering(false)}
  sx={{
    display: { xs: 'none', sm: 'none', md: 'block' },
    width: isSidebarFullyOpen ? drawerWidth : collapsedDrawerWidth,
    flexShrink: 0,
    [`& .MuiDrawer-paper`]: {
      width: isSidebarFullyOpen ? drawerWidth : collapsedDrawerWidth,
      boxSizing: 'border-box',
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  }}
  open
>
  {drawerContent}
</Drawer>

  
        {/* Temporary Drawer (mobile) */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'none' },
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: 'border-box'
            }
          }}
        >
          {drawerContent}
        </Drawer>
  
        {/* Page Content */}
        <Box component="main" sx={{ flexGrow: 1 }} className='rightSideWrap'>
          <Box className="topNavigation">
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box display="flex" alignItems="center">
              <IconButton color="inherit" edge="start" onClick={toggleSidebar} sx={{ mr: 2 }}>
                <MenuIcon />
              </IconButton>
              {!collapsed && (
                <Typography variant="h6" noWrap>
                {pageTitle}
              </Typography>
              )}
            </Box>
  
            <Box display="flex" alignItems="center">
              <IconButton onClick={handleAvatarClick} color="inherit">
                <Avatar
                  alt={displayName}
                  sx={{
                    bgcolor: '#010421',
                    width: 34,
                    height: 34,
                    fontSize: '0.9rem',
                    fontWeight: 700,
                    border: '2px solid rgba(255,255,255,0.4)',
                  }}
                >
                  {avatarInitial}
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{
                  mt: 1,
                  '& .MuiPaper-root': {
                    borderRadius: 2,
                    minWidth: 260,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    overflow: 'hidden',
                  },
                  '& .MuiList-root': { py: 0 },
                }}
              >
                {/* Profile header */}
                <Box
                  sx={{
                    background: 'linear-gradient(135deg, #010421 0%, #0d1b5e 100%)',
                    px: 2.5,
                    py: 2.5,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    pointerEvents: 'none',
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: 'rgba(255,255,255,0.15)',
                      width: 48,
                      height: 48,
                      fontSize: '1.2rem',
                      fontWeight: 700,
                      border: '2px solid rgba(255,255,255,0.35)',
                      color: '#fff',
                      flexShrink: 0,
                    }}
                  >
                    {avatarInitial}
                  </Avatar>
                  <Box sx={{ overflow: 'hidden' }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 700, color: '#fff', lineHeight: 1.4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      {displayName}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: 'rgba(255,255,255,0.6)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
                    >
                      {userDetails?.email ?? ''}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                <MenuItem
                  onClick={() => { handleMenuClose(); handleLogout(); }}
                  sx={{
                    py: 1.5,
                    px: 2.5,
                    color: '#6b7280',
                    '&:hover': { bgcolor: 'rgba(107,114,128,0.06)' },
                  }}
                >
                  <ListItemIcon sx={{ color: '#6b7280', minWidth: 32 }}>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
          </Box>
          <Box className="rightBodySide" sx={{ flexGrow: 1, p: 3 }}>
              {children}
          </Box>
          {/* <Toolbar /> */}
        </Box>
      </Box>
    )
  }
  
  export default AdminLayout


